// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__Knopd","label":"Completed_label__wj9a1"};